import { IMAGES } from '../lib/constants';

export const Gallery = () => {
  const images = IMAGES.gallery;

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-amber-500 font-body text-xs font-semibold uppercase tracking-[0.25em] mb-4">
            Our Work
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-700 text-[#0F1D32] italic">
            Recent Projects
          </h2>
          <p className="mt-4 text-base text-slate-500 font-body max-w-xl mx-auto">
            Quality pool construction across Southern Utah.
          </p>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {images.map((image, index) => (
            <div
              key={index}
              data-testid={`gallery-image-${index}`}
              className={`relative overflow-hidden group cursor-pointer ${
                index === 0
                  ? 'col-span-2 row-span-2'
                  : index === 1
                  ? 'row-span-2'
                  : ''
              }`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                style={{
                  minHeight: index <= 1 ? '500px' : '250px',
                  maxHeight: index <= 1 ? '700px' : '350px',
                }}
                loading="lazy"
              />
              <div className="absolute inset-0 bg-[#0F1D32]/0 group-hover:bg-[#0F1D32]/40 transition-all duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                <p className="text-white text-sm font-body font-medium">{image.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
